<template>
  <div
    v-if="hasAnyUpToDateReview"
    class="workflow-review-checkmark"
    :data-testid="testId"
  >
    <i
      v-tooltip="tooltip"
      class="fa fa-check sf-c-text-dark"
      :class="iconClasses"
    />
  </div>
</template>

<script>
const WorkflowReviewCheckmark = {
  props: ['review', 'reviews', 'iconSize', 'hideTooltip'],
  computed: {
    hasAnyUpToDateReview() {
      return (
        this.reviewed &&
        this.reviews.some((review) => review.outdatedAt === null)
      )
    },
    reviewed() {
      return this.reviews && this.reviews.length > 0
    },
    reviewedByUser() {
      return !!this.review
    },
    testId() {
      return `reviewed-by-${this.reviewedByUser ? 'me' : 'other'}-checkmark`
    },
    tooltip() {
      if (this.hideTooltip || !this.reviewed) return
      return (
        I18n.t('reconciliation_review.reviewed_by') +
        ' ' +
        this.reviews.map((rev) => rev.name).join(', ')
      )
    },
    iconClasses() {
      const classes = [this.iconSize || 'sf-font-l']

      if (this.reviewedByUser) {
        classes.push('sf-c-success-light-1')
      }

      return classes
    },
  },
}

export default WorkflowReviewCheckmark
</script>
